type Listener = (state: PartsState) => void;

export type PartsState = {
  hoveredPart: string | null;
  selectedPart: string | null;
};

/**
 * Single source of truth for "which part is currently hovered/selected".
 * Both the parts list UI and the 3D viewer read from and command this store.
 */
export class PartsStore {
  private state: PartsState = { hoveredPart: null, selectedPart: null };
  private listeners = new Set<Listener>();

  get(): PartsState {
    return this.state;
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }

  setHovered(meshName: string | null) {
    if (this.state.hoveredPart === meshName) return;
    this.state = { ...this.state, hoveredPart: meshName };
    this.notify();
  }

  setSelected(meshName: string | null) {
    if (this.state.selectedPart === meshName) return;
    this.state = { ...this.state, selectedPart: meshName };
    this.notify();
  }

  private notify() {
    for (const l of this.listeners) l(this.state);
  }
}
